import React from "react";
import {Field} from "redux-form";
import {useSelector} from "react-redux";

const CustomListField = ({name, placeholder}) => {
    const error = useSelector(state => state.customValidationErrors.errors[name]);

    return (
        <Field
            id={name}
            component="input"
            type="text"
            name={name}
            className={`form-control form-control-sm ${error ? 'is-invalid' : ''}`}
            placeholder={placeholder}
        />
    );
};

export default CustomListField;
